<template>
    <b-modal size="sm" centered hide-header hide-footer body-class="p-0" ref="create-update-note">
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <p class="text-light m-0 fs-4">Nueva Nota</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg">
            </div>
        </div>
        <div class="d-flex flex-column overflow-auto align-items-center p-2">
            <div class="note w-100 mb-2">
                <div class="note-header d-flex flex-row w-100 p-2 px-3">
                    <textarea rows="1" type="text" v-model="note.title" class="note-title d-flex m-0 fw-bold w-100" placeholder="Titulo"></textarea>
                </div>
                <div class="note-body d-flex flex-column w-100 p-2 px-3">
                    <textarea rows="6" class="note-text m-0" type="text" v-model="note.message" placeholder="Mensaje"></textarea>
                </div>
            </div>
            <b-button type="submit" variant="primary" class="w-100" @click="saveNote">Guardar Nota</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import NoteService from '@/api/services/note.service';
import INoteDto from '@/models/dto/INote.dto';
import DateUtil from '@/utils/date.util';
import { Component, Emit, Vue } from 'vue-property-decorator';
@Component({})
export default class CreateNote extends Vue {

    note: INoteDto = {
        deviceid: 0,
        message: "",
        title: "",
    }

    close() {
        const modal: any = this.$refs['create-update-note']
        modal.hide();
    }

    show() {
        const modal: any = this.$refs['create-update-note']
        modal.show();
    }

    @Emit('saveNote')
    async saveNote(): Promise<INoteDto> {
        console.log(this.note)
        const note =  (await NoteService.createNote(this.note)).data
        note.created_at = DateUtil.getGenericFormat(note.created_at)
        return note
    }
}

</script>

<style lang="sass">
    .note
        .note-header
            background: #FEEA89
            svg
                height: 20px !important
            .note-title
                resize: none
                font-size: 16px
                border: none
                background: none
                font-family: 'Changa', sans-serif !important
                line-height: normal
                &:focus-visible
                    border: none
                    outline: none
        .note-body
            background: #fff3cd
            .note-text
                resize: none
                font-family: 'Changa', sans-serif !important
                font-size: 12px !important
                text-align: justify
                border: none
                background: none
                line-height: normal
                &:focus-visible
                    border: none
                    outline: none
                
    .modal-header
        height: 60px !important
        img
            height: 45px

    .close-modal
        height: 20px
        cursor: pointer
        transition: all .1s ease
        &:active
            transform: scale(0.9)
            
        img
            height: 100%

</style>